module.exports = __webpack_public_path__ + "assets/img/detail-img2-9fffbbcb.png";